import Vue from 'vue';
import JsonViewer from 'vue-json-viewer';

import 'vue-json-viewer/style.css';

// Import JsonViewer as a Vue.js plugin
Vue.use(JsonViewer);
